import { useAuth } from '@/hooks/use-auth';
import {
  EMPTY_RECENT_APP_IDS,
  useRecentAppsStore,
} from '@/stores/recent-apps.store';

interface UseRecentAppsResult {
  recentAppIds: string[];
  addRecentApp: (appId: string) => void;
}

export function useRecentApps(): UseRecentAppsResult {
  const userId = useAuth().user?.id ?? '';
  const recentAppIds = useRecentAppsStore(state =>
    userId
      ? (state.byUser[userId] ?? EMPTY_RECENT_APP_IDS)
      : EMPTY_RECENT_APP_IDS
  );
  const addRecentAppToStore = useRecentAppsStore(state => state.addRecentApp);

  return {
    recentAppIds,
    addRecentApp: (appId: string) => {
      if (!userId) {
        return;
      }

      addRecentAppToStore(userId, appId);
    },
  };
}
